// Which guide the header's User Guide button opens (owner, 2026-10-20 — D-389).
//
// Each Invoices step, Notifications and Analytics has a one-pager of its own,
// written for the people who work that page; the button opens it. References,
// Rules, Assignments and Errors keep the full guide, which covers every page.
//
// The PDFs ship as static assets beside index.html (app/public/), rendered from
// docs/guide/ by docs/guide/build.mjs. Root-relative on purpose: the SPA is
// served from the distribution root in every environment, so these need no
// runtime configuration.
import type { NodeKey } from './constants'

/** The full guide, for every page without a one-pager of its own. */
const FULL_GUIDE_URL = '/user-guide.pdf'

/** Pages with a one-pager, keyed as `App.tsx` keys its selected page, mapped
    to the file's name under app/public/guides/ and docs/guide/one-pagers/. */
const ONE_PAGER_FILES: Record<NodeKey | 'notifications' | 'dashboard', string> = {
  'import-control': 'import-control',
  controller: 'controller-approval',
  department: 'manager-approval',
  director: 'director-approval',
  oversight: 'oversight-approval',
  'export-control': 'export-control',
  'closing-confirmation': 'closing-confirmation',
  'denial-review': 'denial-review',
  archives: 'archives',
  notifications: 'notifications',
  // Analytics' page key is 'dashboard' whichever of its two tabs is open; the
  // one-pager covers both.
  dashboard: 'analytics',
}

/** The guide for the page on screen: its one-pager, else the full guide. */
export function guideUrlFor(page: string | null): string {
  const file = page !== null ? (ONE_PAGER_FILES as Record<string, string>)[page] : undefined
  return file ? `/guides/${file}.pdf` : FULL_GUIDE_URL
}
